export default __webpack_public_path__ + "static/media/end-date.40aa15f7.svg";